import {
  Box,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Spinner,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { MdMyLocation, MdSearch } from "react-icons/md";

import { Button } from "@components/atoms";

type SamedayPickupLocationInputProps = {
  autocompleteInputRef: React.RefObject<HTMLInputElement>;
  errorMessage: string;
  handleUseCurrentLocation: () => void;
  loading: boolean;
  reset: () => void;
  setIsDrawerOpen: (isDrawerOpen: boolean) => void;
  distance?: string;
};

export const SamedayPickupLocationInput: React.FC<
  SamedayPickupLocationInputProps
> = ({
  autocompleteInputRef,
  errorMessage,
  handleUseCurrentLocation,
  loading,
  reset,
  setIsDrawerOpen,
  distance,
}) => (
  <Stack gap="0.25rem">
    <InputGroup>
      <Input
        ref={autocompleteInputRef}
        disabled={loading}
        placeholder="Search postcode or suburb"
        onChange={reset}
      />
      <InputLeftElement>
        <MdSearch size={24} />
      </InputLeftElement>
      {loading && (
        <InputRightElement>
          <Spinner size="sm" />
        </InputRightElement>
      )}
    </InputGroup>
    {errorMessage && (
      <Text as="span" color="red" fontSize="small">
        {errorMessage}
      </Text>
    )}
    {!distance ? (
      <Stack>
        <Text as="span" fontSize="small">
          Start typing and choose a postcode or suburb from the list
        </Text>
        <Box
          alignItems="center"
          alignSelf="center"
          cursor={loading ? "not-allowed" : "pointer"}
          display="flex"
          gap="0.5rem"
          maxWidth="fit-content"
          onClick={handleUseCurrentLocation}
        >
          <>
            <MdMyLocation size={20} />
            <Text as="span" borderBottom="2px solid black">
              Use my current location
            </Text>
          </>
        </Box>
      </Stack>
    ) : (
      <Button onClick={() => setIsDrawerOpen(false)}>Continue</Button>
    )}
  </Stack>
);
